export default {
    /**
     * 安装到Vue环境
     * @param {*} Vue
     */
    install: (Vue) => {
        // 一些公共css
        require('./index.scss');
    }
};
